import _isEmpty from 'lodash/isEmpty';
export default function useEventPropagation() {
  var targetAttributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  function shouldPreventPropagation(e) {
    var _e$target = e.target,
      target = _e$target === void 0 ? {} : _e$target;
    var _target$attributes = target.attributes,
      attributes = _target$attributes === void 0 ? {} : _target$attributes;
    if (_isEmpty(targetAttributes)) {
      return true;
    }
    return targetAttributes.some(function (attribute) {
      return Boolean(attributes[attribute]);
    });
  }
  function shouldAllowPropagation(e) {
    return !shouldPreventPropagation(e);
  }
  function preventPropagation(e, _ref) {
    var _ref$preventDefault = _ref.preventDefault,
      preventDefault = _ref$preventDefault === void 0 ? false : _ref$preventDefault;
    if (preventDefault) {
      e.preventDefault();
    }
    if (shouldPreventPropagation(e)) {
      e.stopPropagation();
    }
  }
  return {
    shouldAllowPropagation: shouldAllowPropagation,
    shouldPreventPropagation: shouldPreventPropagation,
    preventPropagation: preventPropagation
  };
}